import React from 'react';
import CartTable from './CartTable';

const OrderConfirmation = (props) => (
     <div className="order-confirmation">
        <section>
            <h2>Hóa Đơn</h2>
            <h4>Thông tin khách hàng</h4>
            <p>Tên : {props.value.name}</p>
            <p>Số điện thoại : {props.value.phone}</p>
            <p>Email : {props.value.email}</p>
            <p>Địa chỉ : {props.value.address}</p>
            <CartTable readOnly={true} />
        </section>
    </div>
)



export default OrderConfirmation 